export const TAG = 'ManageFunds';

export const CASH_BALANCE_QUERY_KEY = 'cashBalanceSummary';

export enum AvailableCashType {
  Transfer = 'T',
  Withdrawal = 'W',
}
